import api from "api";

export const fetchVideos = async (folderPath, token, options = {}) => {
  try {
    const response = await api.post(
      "/projects/list_files",
      {
        folder_path: folderPath
      },
      {
        headers: { Authorization: `Bearer ${token}` },
        ...options
      }
    );

    return response.data.files.map(video => ({
      ...video,
      thumbnail: video.thumbnail || generateThumbnailUrl(video.url)
    }));
  } catch (error) {
    console.error("Error fetching videos:", error);
    throw error;
  }
};

const generateThumbnailUrl = videoUrl => {
  return null;
};

const toCanonicalReportsFolderBase = folderPath => {
  if (!folderPath) return folderPath;
  const clean = String(folderPath).replace(/\/+$/, "");
  const parts = clean.split("/");
  const projetosIdx = parts.indexOf("projetos");
  if (
    projetosIdx !== -1 &&
    parts[projetosIdx + 1] &&
    parts[projetosIdx + 2]
  ) {
    return `projetos/${parts[projetosIdx + 1]}/${parts[projetosIdx + 2]}`;
  }
  if (parts[0] === "projetos" && parts[1] && parts[2]) {
    return `projetos/${parts[1]}/${parts[2]}`;
  }
  return clean;
};

export const saveReport = async (reports, folderPath, token) => {
  try {
    const canonicalBase = toCanonicalReportsFolderBase(folderPath);
    const results = await Promise.all(
      reports.map(async report => {
        try {
          const payload = {
            folder_path: canonicalBase.endsWith('/') ? canonicalBase : `${canonicalBase}/`,
            image_data: report.image,
            image_info: {
              titulo: report.title || "Sem título",
              descricao: report.description || "Não informada",
              acao: report.action || "Não informada",
              severidade: report.severity || "Não informada"
            }
          };

          const response = await api.post("/projects/save_snapshot", payload, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          });

          if (response.data?.status === "error") {
            throw new Error(response.data.message || "Erro ao salvar relatório");
          }
          return { success: true, data: response.data };
        } catch (error) {
          console.error("Error saving report:", error);
          return {
            success: false,
            error: error.response?.data?.message || "Erro ao salvar relatório"
          };
        }
      })
    );

    const allSuccess = results.every(result => result.success);

    return {
      success: allSuccess,
      results: results,
      savedCount: results.filter(r => r.success).length
    };
  } catch (error) {
    console.error("Error in saveReport:", error);
    throw error;
  }
};
